// extracted by mini-css-extract-plugin
export var bold = "_redotech-redo-return-app-src-order-order-tracking-fulfillment-expiration-countdown-bold";